<template>
    <div>
        <b-card>
            <h3 style="margin-bottom: 20px;">Importar CSV de Bancos</h3>
            <div>
                <b-row class="match-height">
                    <b-col md="2">
                        <b-form-group label-for="v-bank">
                        <v-select
                            id="v-bank"
                            v-model="selectedBank"
                            :options="banks"
                            label="text"
                        />
                        </b-form-group>
                    </b-col>
                    <b-col cols="8">
                        <b-form-file
                            v-model="csvInput"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                        />
                    </b-col>
                    <b-col cols="2">
                        <b-button
                            variant="outline-primary"
                            @click="procesarFichero"
                        > Procesar
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
        <b-card>
            <h3 style="margin-bottom: 20px;">Gastos</h3>

            <b-table
                :items="formartedItems"
                :fields="columnasTable"
                class="table table-borderless table-pagos"
                no-border-collapse
                sort-icon-left
                ref="tablePagos"
            >
                <template #cell(_contabilizado)="data">
                    <span v-if="!data.item.contabilizado" class="btn-no-contabilizado" @click="contabilizadoUpdate(data.item, true)" >
                        <i class="fa-solid fa-xmark"></i>
                    </span>
                    <span v-else class="btn-contabilizado" @click="contabilizadoUpdate(data.item, false)">
                        <i class="fa-solid fa-check"></i>
                    </span>
                    
                </template>
            </b-table>
        </b-card>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import BCardCode from '@core/components/b-card-code'
    import { BRow, BCol, BFormFile, BButton  } from 'bootstrap-vue'
    import { BTable } from 'bootstrap-vue'
    import axios from '@axios'
    import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

    import Papa from "papaparse";

    import * as XLSX from 'xlsx';
    import { ChevronLeftIcon } from 'vue-feather-icons'

    //sheetsJS

export default {
    components: {
            BCardCode,
            BRow,
            BCol,
            BFormFile,
            BButton,
            vSelect,
            BTable,
            ToastificationContent
        },
    data() {
        return {
            banks: [ 
                {   
                    value: "Ibercaja", text: "Ibercaja", typeFile: 'xls',
                    cFecha: 1, cDescripcion: 4, cConcepto: 3, cPrecio: 6, divisa: 'EUR'
                },
                {   
                    value: "Revolut", text: "Revolut", typeFile: 'csv',
                    cFecha: 0, cDescripcion: 7, cConcepto: 8, cPrecio: 17, divisa: 'GBP' 
                },
                {   
                    value: "Sabadell", text: "Sabadell", typeFile: 'xls',
                    cFecha: 0, cDescripcion: 1, cConcepto: 5, cPrecio: 3, divisa: 'EUR' 
                },
                {   
                    value: "HSBC", text: "HSBC", typeFile: 'csv',
                    cFecha: 0, cDescripcion: 2, cConcepto: 1, cPrecio: 3, cPrecioIn: 4, divisa: 'GBP' 
                },
            ],
            selectedBank: null,
            csvInput: [],
            data: [],
            allDatos: [],
            columnasTable: [
                {
                key: "_contabilizado",
                label: "Check",
                sortable: true,
                thStyle: { width: "1%" },
                },
                {
                key: "banco",
                label: "Banco",
                sortable: true,
                },
                {
                key: "precio",
                label: "Precio",
                sortable: true,
                },  
                {
                key: "descripcion",
                label: "Descripcion",
                sortable: true,
                },
                {
                key: "concepto",
                label: "Concepto",
                sortable: true,
                },
                {
                key: "fecha",
                label: "Fecha",
                sortable: true,
                },
                

            ],
        };
    },
    computed: {
        formartedItems () {
        
            return this.allDatos
                .filter(item => item.precio > 0)
                .map(item => {
                    
                    item._rowVariant = item.contabilizado ? 'success': '';
                    return item;
                })
        }
    },
    methods: {    
        loadItems(){

            Promise.all([
                    axios.get("/kpi/banco"),
                ]).then(responses => {
                    const [bancoResponse] = responses;

                    this.allDatos = bancoResponse.data.map(item => {
                        item.fecha = item.fecha.split('T')[0];
                        item.fecha = item.fecha.split('-')[2] + '-' + item.fecha.split('-')[1] + '-' + item.fecha.split('-')[0];
                        return item;
                    });

                });

        },
        procesarFichero(){
            if(this.selectedBank == null)
                return;

            if(this.csvInput.name.includes('.xls')) {
                this.procesarXls();                
            }
            else {
                this.procesarCsv();
            }

        },
        procesarCsv(){
            var reader = new FileReader();

            reader.onload = (e) => {
               let csvText = reader.result;

               let jsonData = Papa.parse(csvText, {
                    delimiter: ",", 
                    quoteChar: '"',
                    header: true,
                    skipEmptyLines: true
                }).data;

                this.data = this.parseDatos(jsonData);

                this.guardarDatos(this.data);
            }

            reader.readAsText(this.csvInput);
        },
        procesarXls(){

            var reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });

                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                const jsonData = XLSX.utils.sheet_to_json(sheet);

                this.data = this.parseDatos(jsonData);

                this.guardarDatos(this.data);
            };

            reader.readAsArrayBuffer(this.csvInput);
        },
        parseDatos(datos){

            let newDatos = datos.map(row => {

                let precio = parseFloat(Object.values(row)[this.selectedBank.cPrecio]);

                if(this.selectedBank.value == 'HSBC'){
                    if(Object.values(row)[this.selectedBank.cPrecio])
                        precio = parseFloat(Object.values(row)[this.selectedBank.cPrecio]);
                    else if(Object.values(row)[this.selectedBank.cPrecioIn])
                        precio = -parseFloat(Object.values(row)[this.selectedBank.cPrecioIn]);
                }

                let newData = {
                    fecha: Object.values(row)[this.selectedBank.cFecha],
                    descripcion: Object.values(row)[this.selectedBank.cDescripcion],
                    concepto: Object.values(row)[this.selectedBank.cConcepto],
                    precio: precio,
                    divisa: this.selectedBank.divisa,
                    banco: this.selectedBank.value,
                    empresa: '',
                    contabilizado: false,
                    idKpiPago: 0
                }

                newData.fecha = new Date(newData.fecha);

                return newData;

            });

            return newDatos.filter(item => 
                item &&
                item.precio !== undefined && 
                !isNaN(parseFloat(item.precio)) && 
                parseFloat(item.precio) != 0
            );

        },
        guardarDatos(datos){

            axios
                .post("/kpi/banco/array", datos)
                .then(response => {
                    return response.data;
                })
                .then(res => {

                    if(res.success)
                    {
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: "Movimientos guardados correctamente",
                                icon: "EditIcon",
                                variant: "success",
                            },
                            });   

                            this.data = [];
                            this.selectedBank = null;
                            this.csvInput = [];
                    }

                }).catch(err => {
                    this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: "Se ha producido un error al guardarlos",
                                icon: "EditIcon",
                                variant: "danger",
                            },
                            });   
                });


        },
        contabilizadoUpdate(item, estado)
        {

            item.contabilizado = estado;

            axios
                .put("/kpi/banco", item)
                .then(response => {
                    return response.data;
                })
                .then(res => {

                });

        }
    },
    mounted() {    
      this.loadItems();
  },
};
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/vue-wizard.scss";
    @import "@core/scss/vue/libs/vue-select.scss";

    .btn-no-contabilizado{
        color: red;
    }
    .btn-no-contabilizado:hover{
        cursor: pointer;
    }

    .btn-contabilizado{
        color: green;
    }
    .btn-contabilizado:hover{
        cursor: pointer;
    }
</style>